import ProductCarousel from "@/components/pages/product.js/product-carousel";
import React from "react";
import { sanitize } from "@/framework/utils/sanitize";
import { products } from "@/data/products";
import Seo from "@/utils/seo";
import ProductCard from "@/components/pages/product.js/product-card";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import SectionHeading from "@/components/ui/carousel/section-heading";
import { categories } from "@/data/categories";
export default function ProductPage({ product, recommended }) {
  const breakpoints = {
    1280: {
      slidesPerView: 3.4,
      spaceBetween: 30,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    991: {
      slidesPerView: 2.4,
      spaceBetween: 20,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.1,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 2.25,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <>
      <Seo
        metaTitle={`Buy ${product?.name} | Rose Bowl`}
        slug={`product/${product?.slug}`}
      />
      <ProductCarousel product={product} />
      <div className="w-full gap-8 flex flex-col py-12 bg-darkBeige overflow-hidden">
        <SectionHeading
          title="You may also like"
          tag={product?.category?.data?.attributes?.name}
        />
        <div className="w-full mt-4 mb-8">
          <Carousel
            slidesPerView={3.4}
            spaceBetween={30}
            loop={false}
            className="featureCarousel w-full my-8"
            breakpoints={breakpoints}
            navigation={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
            }}
            title="Press & Media"
          >
            {recommended?.products?.data?.map((product, key) => (
              <SwiperSlide key={"reco" + key}>
                <ProductCard product={sanitize(product)} />
              </SwiperSlide>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ params = {} } = {}) {
  let props = {};
  try {
    const data = sanitize(
      products.find((product) => product.attributes?.slug === params.slug)
    );
    const recommended = categories.find(
      (cat) => cat.slug === data?.category?.data?.attributes?.slug
    );
    props = {
      product: data ?? [],
      recommended: recommended ?? [],
    };
  } catch (error) {
    console.log(error);
  }
  return {
    props: props,
    // revalidate: 10,
  };
}
export async function getStaticPaths() {
  let paths = [];
  try {
    paths = products.map((product) => {
      return {
        params: {
          slug: product.attributes?.slug,
        },
      };
    });
  } catch (error) {
    //console.log(error.networkError.result);
  }
  return {
    paths,
    fallback: false,
  };
}
